import { sendDtmf } from "../../lib/dtmf";

const KEYS = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  ["*", "0", "#"],
];

const SUB_LABELS: Record<string, string> = {
  "2": "ABC",
  "3": "DEF",
  "4": "GHI",
  "5": "JKL",
  "6": "MNO",
  "7": "PQRS",
  "8": "TUV",
  "9": "WXYZ",
  "0": "+",
};

export const DtmfPad = ({ session }: { session: any }) => (
  <div className="grid grid-cols-3 gap-2 mt-4 w-full max-w-[200px] mx-auto">
    {KEYS.flat().map((key) => (
      <button
        key={key}
        onClick={() => sendDtmf(session, key)}
        className="w-14 h-14 mx-auto rounded-full bg-white/10 hover:bg-white/20 active:bg-white/30 flex flex-col items-center justify-center transition-colors"
      >
        <span className="text-white text-lg font-medium leading-none">{key}</span>
        {SUB_LABELS[key] && (
          <span className="text-white/40 text-[9px] tracking-widest leading-none mt-0.5">
            {SUB_LABELS[key]}
          </span>
        )}
      </button>
    ))}
  </div>
);
